import type { LocalizationMap } from '@Primitive/Localization/Localization';
import _ from 'lodash';

export const CVViewerWidgetMapKey = "Primitive_CVViewer";
// ------------------------------------------------------------------------------------------------
export const enum CVViewerUILabelKey {
    ResetZoom = "reset-zoom",
    ShowFace = "show-face",
    ShowHeatMap = "show-heatmap",
    RegionsLabel = "regions-label",
    RegionsAdd = "regions-add",
    RegionsDelete = "regions-delete",
    RegionsSave = "regions-save",
};
// ------------------------------------------------------------------------------------------------
export const defaultLabelForUILabelKey: { [key: string]: string } = {
    [CVViewerUILabelKey.ResetZoom]: "Reset Zoom",
    [CVViewerUILabelKey.ShowFace]: "Show Face",
    [CVViewerUILabelKey.ShowHeatMap]: "Show Heatmap",
    [CVViewerUILabelKey.RegionsLabel]: "Regions",
    [CVViewerUILabelKey.RegionsAdd]: "Add",
    [CVViewerUILabelKey.RegionsDelete]: "Delete",
    [CVViewerUILabelKey.RegionsSave]: "Save",
};
// ------------------------------------------------------------------------------------------------
export function GetCVViewerWidgetLocalizationDictionary(): LocalizationMap {

    const keys = [
        CVViewerUILabelKey.ResetZoom,
        CVViewerUILabelKey.ShowFace,
        CVViewerUILabelKey.ShowHeatMap,
        CVViewerUILabelKey.RegionsLabel,
        CVViewerUILabelKey.RegionsAdd,
        CVViewerUILabelKey.RegionsDelete,
        CVViewerUILabelKey.RegionsSave
    ];

    const res = {};
    _.forEach(keys, (key) => {
        res[key] = defaultLabelForUILabelKey[key];
    });

    return res;
}
// ------------------------------------------------------------------------------------------------